import { ClippingPlanes, ClipId } from '../../models/clipping-plane.model';

export const defaultClippingPlanes: ClippingPlanes = {
  enabled: false,
  clips: {
    left: {
      clipId: ClipId.LeftClip,
      enabled: false,
      fade: false,
      fadeDistance: 0,
      progress: 0,
    },
    right: {
      clipId: ClipId.RightClip,
      enabled: false,
      fade: false,
      fadeDistance: 0,
      progress: 0,
    },
    back: {
      clipId: ClipId.BackClip,
      enabled: false,
      fade: false,
      fadeDistance: 0,
      progress: 0,
    },
    front: {
      clipId: ClipId.FrontClip,
      enabled: false,
      fade: false,
      fadeDistance: 0,
      progress: 0,
    },
    top: {
      clipId: ClipId.TopClip,
      enabled: false,
      fade: false,
      fadeDistance: 0,
      progress: 0,
    },
    bottom: {
      clipId: ClipId.BottomClip,
      enabled: false,
      fade: false,
      fadeDistance: 0,
      progress: 0,
    },
  },
};
